<template>
  <div>
    <div class="flex flex-wrap p-b-12">
      <div class="m-8 bg-FF b-r-8 flex col-center p-16" style="width: 47.6%">
        <div class="w-80 h-80 m-r-16">
          <img alt="item.label" class="width-100 height-100" src="@/assets/icon/employeeKanban/geshui.png">
        </div>
        <div>
          <div class="font-40 font-weight-700 m-b-16">{{statisticsData?.contractInfo}}<span class="font-20"> 万元</span></div>
          <div class="font-24">新签合同</div>
        </div>
      </div>
      <div class="m-8 bg-FF b-r-8 flex col-center p-16" style="width: 47.6%">
        <div class="w-80 h-80 m-r-16">
          <img alt="公积金扣款" class="width-100 height-100" src="@/assets/icon/employeeKanban/gongjijin.png">
        </div>
        <div>
          <div class="font-40 font-weight-700 m-b-16">{{statisticsData?.invoiceInfo}}<span class="font-20"> 万元</span></div>
          <div class="font-24">已开发票</div>
        </div>
      </div>
      <div class="m-8 bg-FF b-r-8 flex col-center p-16" style="width: 47.6%">
        <div class="w-80 h-80 m-r-16">
          <img alt="社保扣款" class="width-100 height-100" src="@/assets/icon/employeeKanban/shebao.png">
        </div>
        <div>
          <div class="font-40 font-weight-700 m-b-16">{{statisticsData?.debtInfo}}<span class="font-20"> 万元</span></div>
          <div class="font-24">累计应收欠款</div>
        </div>
      </div>
      <div class="m-8 bg-FF b-r-8 flex col-center p-16" style="width: 47.6%">
        <div class="w-80 h-80 m-r-16">
          <img alt="其他扣款" class="width-100 height-100" src="@/assets/icon/employeeKanban/qita.png">
        </div>
        <div>
          <div class="font-40 font-weight-700 m-b-16">{{statisticsData?.invoiceNotReceive}}<span class="font-20"> 万元</span></div>
          <div class="font-24">已开票未回款</div>
        </div>
      </div>
    </div>

    <!-- 前五业务合同分析 -->
    <div class="bg-FF p-16 m-b-12 b-r-8">
      <div class="flex space-between col-center m-b-20">
        <TitleLogo></TitleLogo>
        <span class="font-32 font-weight-500">前五业务合同分析</span>
      </div>

      <div id="htfxPie" ref="htfxPie" style="width: 90vw; height: 280px;"></div>
    </div>

    <!-- 欠款统计 -->
    <div class="bg-FF p-16 m-b-12 b-r-8">
      <div class="flex space-between col-center m-b-20">
        <TitleLogo></TitleLogo>
        <span class="font-32 font-weight-500">欠款统计</span>
      </div>

      <div id="qktjBar" ref="qktjBar" style="width: 90vw; height: 220px;"></div>
    </div>
  </div>
</template>
<script>

import TitleLogo from "@/components/TitleLogo.vue";
import * as echarts from "echarts";
import echartMixin from "@/mixin/echartMixin";

export default {
  components: {TitleLogo},
  mixins: [echartMixin],
  props: {
    statisticsData: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      htfxPie: null,
      qktjBar: null
    }
  },
  watch: {
    statisticsData: {
      handler(newVal) {
        if (newVal.contractAnalysis) {
          this.inithtfxPie(newVal.contractAnalysis)

          let barSeriesData = []
          newVal.debtStats.statDatas.forEach(item => {
            barSeriesData.push(this.getRoundedStackBarSeriesObj(item))
          })
          this.initqktjBar(newVal.debtStats.seriesNameList, newVal.debtStats.unitNameList, barSeriesData)
        }
      },
      immediate: true // 立即执行一次，确保初始数据也能触发
    }
  },
  created() {
  },
  mounted() {},
  methods: {
    inithtfxPie(seriesData) {
      const htfxPieDom = this.$refs.htfxPie
      if (htfxPieDom) {
        echarts.dispose(htfxPieDom);
        this.htfxPie = echarts.init(htfxPieDom);
        const option = {
          tooltip: {
            trigger: 'item',
            formatter: '{b}<br/> {d}%',
            confine: true
          },
          legend: {
            bottom: '0',
            icon:'circle',
          },
          series: [
            {
              name: '',
              type: 'pie',
              radius: [25, 90],
              center: ['50%', '41%'],
              // roseType: 'radius',
              // roseType: 'area',
              label: {
                show: true,
                position: 'outside',
                formatter: function(params) {
                  const name = params.name
                  const percent = params.percent + '%'
                  return `${percent}`
                },
              },
              labelLine: {
                lineStyle: {
                  color: '#999999'
                },
                smooth: 0.2,
                length: 15,
                length2: 8
              },
              itemStyle:{
                borderRadius: 8,
                borderWidth:4,
                borderColor:'#ffffff',
              },
              data: seriesData
            }
          ]
        };
        this.htfxPie.setOption(option);

        window.addEventListener('resize', () => {
          this.htfxPie.resize();
        });
      }
    },
    initqktjBar(legendData, xAxisData, seriesData) {
      const qktjBarDom = this.$refs.qktjBar
      if (qktjBarDom) {
        echarts.dispose(qktjBarDom);
        this.qktjBar = echarts.init(qktjBarDom);
        const option = {
          tooltip : {
            trigger: 'axis',
            confine: true
          },
          legend: {
            data: legendData,
            top: '2%',
            left: '2%',
            itemWidth: 15, // 设置宽度
            itemHeight: 10 // 设置高度
          },
          grid: {
            // top: '20%',
            left: '3%',
            right: '4%',
            bottom: '2%',
            containLabel: true
          },
          xAxis:  {
            type: 'category',
            data: xAxisData,
            axisLabel: {
              interval: 0,
              formatter: function (params) {
                var str = "";                 // 最终拼接成的字符串
                var paramsLen = params.length;// 获取每项文字的个数
                var len = 3;                  // 每行能显示的字的个数（根据实际情况自己设置）
                var rowNumber = Math.ceil(paramsLen / len); // 换行的话，需要显示几行，向上取整
                if (paramsLen > len) {        //大于设定的len就换行，不大于就不变化
                  for (var i = 0; i < rowNumber; i++) {
                    var temp = "";            // 表示每一次截取的字符串
                    var start = i * len;      // 开始截取的位置
                    var end = start + len;    // 结束截取的位置
                    if (i == rowNumber - 1) { // 最后一次不换行
                      temp = params.substring(start, paramsLen);
                    } else {                  // 每一次拼接字符串并换行
                      temp = params.substring(start, end) + "\n";
                    }
                    str += temp;              // 最终拼成的字符串
                  }
                } else {                      // 给新的字符串赋值
                  str = params;
                }
                return str;                   //返回字符串
              }
            },
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
          },
          yAxis: {
            type: 'value',
            name: '(万元)',
            axisLabel: {
              formatter: '{value}'
            },
            axisLine: {      // y轴
              show: false
            },
            axisTick: {       //y轴刻度线
              show: false
            },
          },
          color: ['#2EC7C9', '#FFB980', '#B6A2DE'],
          series: seriesData
        };
        this.qktjBar.setOption(option);

        window.addEventListener('resize', () => {
          this.qktjBar.resize();
        });
      }
    }
  }
}
</script>
<style lang="less" scoped>
</style>
